import React from "react";
import { Route } from "react-router-dom";
import HomeViewV2 from "./components/HomeViewV2";
import TopologyView from "../ctxReflectorV2/views/TopologyView";
import InsightTopologyViewV2 from "./views/InsightTopologyViewV2";
import OptimizationHub from "./components/OptimizationHub";
import InsightLayout from "./components/InsightLayout";
import UsersPage from "../settings/account/components/Users/UsersPage";
import CustomersPage from "../settings/account/components/Customers/CustomersPage";
import RequestPage from "../settings/support/RequestPage";
import { isInsightTopologyV2Enabled } from "@shared/config/featureFlags";

// Wrapper component to apply InsightLayout to all Insight views
const withInsightLayout = (Component: React.ComponentType, showTrialBanner = true) => (
  <InsightLayout showTrialBanner={showTrialBanner}>
    <Component />
  </InsightLayout>
);

export const insightRoutes = [
  // Home
  <Route key="insight-home" path="insight" element={withInsightLayout(HomeViewV2)} />,
  <Route key="insight-home-2" path="insight/home" element={withInsightLayout(HomeViewV2)} />,
  // Main topology view (legacy, static-artifact based — stays the default
  // until Daniel accepts the CTX-97 localhost vertical slice)
  <Route key="insight-topology" path="insight/topology/*" element={withInsightLayout(TopologyView)} />,
  <Route key="insight-overview" path="insight/overview" element={withInsightLayout(TopologyView)} />,
  // CTX-97 — new source-first Topology view backed by the CTX-96
  // chopper-backend contract. Development-only parallel route; renders its
  // own <InsightLayout> (no trial banner), so it is NOT wrapped by
  // `withInsightLayout` here. Never routed to in production builds.
  ...(isInsightTopologyV2Enabled()
    ? [<Route key="insight-topology-v2" path="insight/topology-v2/*" element={<InsightTopologyViewV2 />} />]
    : []),
  // Optimization Hub
  <Route key="insight-optimization" path="insight/optimization" element={withInsightLayout(OptimizationHub)} />,
  // Settings - No trial banner for admin/settings pages
  <Route key="insight-users" path="insight/account/users" element={withInsightLayout(UsersPage, false)} />,
  <Route key="insight-customers" path="insight/account/customers" element={withInsightLayout(CustomersPage, false)} />,
  <Route key="insight-request" path="insight/support/request" element={withInsightLayout(RequestPage, false)} />,
];

